module.exports = __webpack_public_path__ + "list-no-data-bg.png?8d075455b126d62918cce2ae2a39c3d7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-no-data-bg.png
// module id = 355
// module chunks = 5